import api from './api';

interface LotacaoDestino {
  codigo: string;
  centroCusto: string;
}

export const getLotacaoDestinoByCodigo = (codigo: string) => api.get<LotacaoDestino>(`lotacaoDestino/${codigo}`);
export const getAllLotacaoDestino = () => api.get<LotacaoDestino[]>('lotacaoDestino');
export const getAllLotacaoDestinoOptions = () =>
  getAllLotacaoDestino().then(cc => (cc || []).map(item => ({ text: item.codigo, value: item.codigo })));
